export default __webpack_public_path__ + "static/media/blog.ae70dcf3.png";